import { LabelMiniStrong } from '@liveauctioneers/hammer-ui-core/text';

import { AuctionCardClickedTrigger } from '@/utils/amplitude/analytics/catalog/trackAuctionCardClicked.analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { CoverImage, CoverImageTile } from './CoverImageTile';

type Props = {
    catalogUrl: string;
    coverImages: CoverImage[];
    lazyLoadImages?: boolean;
    moreLotsCount: number;
    rel: string;
};

export const HomepageAuctionCardMobileCollage = ({
    catalogUrl,
    coverImages,
    lazyLoadImages,
    moreLotsCount,
    rel,
}: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <div
            className="relative flex"
            data-testid="homepage-auction-card-mobile-collage"
            data-track-trigger={AuctionCardClickedTrigger.ImageClick}
        >
            <CoverImageTile
                className="size-[186px] shrink-0"
                image={coverImages[0]}
                lazyLoadImages={lazyLoadImages}
                rel={rel}
                to={catalogUrl}
            />
            <div className="flex flex-col">
                <CoverImageTile
                    className="size-[94px] shrink-0"
                    image={coverImages[1]}
                    lazyLoadImages={lazyLoadImages}
                    rel={rel}
                    to={catalogUrl}
                />
                <div className="relative size-[94px] shrink-0">
                    <CoverImageTile
                        className="h-full w-full"
                        image={coverImages[2]}
                        lazyLoadImages={lazyLoadImages}
                        rel={rel}
                        to={catalogUrl}
                    />
                    {moreLotsCount > 0 && (
                        <div
                            className="pointer-events-none absolute inset-0 flex items-center justify-center bg-background-overlay"
                            data-testid="homepage-auction-card-more-lots-overlay"
                        >
                            <LabelMiniStrong
                                className="uppercase"
                                color="inverse"
                            >
                                {formatMessage(['catalog_card', 'homepage', 'moreLotsCount'], {
                                    values: { count: moreLotsCount },
                                })}
                            </LabelMiniStrong>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
